import React, {FunctionComponent, useState} from "react";
import NiceModal, {NiceModalHocProps, useModal} from "@ebay/nice-modal-react";
import {Colors, Container, CustomDialog, Text} from "bounce-ui/backoffice";
import {IPlanMatrix} from "../../../../../../../declerations/server/payment_plan_models";
import {InputAdornment, TextField, Typography} from "@mui/material";
import {divide} from "@bounce/shared/helpers";

export type FilterOffersDialogProps = {
  totalBalance: number;
  allPlanOffers: IPlanMatrix[][];
  setFilteredPlanOffers: (planOffers: (IPlanMatrix | null)[][]) => void;
  minAmount: number;
  setMinAmount: (min: number) => void;
  maxAmount: number;
  setMaxAmount: (max: number) => void;
  isSupervisorView: boolean;
};
const FilterOffersDialog: FunctionComponent<FilterOffersDialogProps & NiceModalHocProps> = NiceModal.create(
  ({totalBalance, allPlanOffers, setFilteredPlanOffers, minAmount, maxAmount, isSupervisorView}) => {
    const modal = useModal();
    const [min, setMin] = useState<number>(minAmount);
    const [max, setMax] = useState<number>(maxAmount);

    const onApplyFilter = () => {
      const filtered = allPlanOffers.map((row) =>
        row.map((plan) => {
          if (!plan) return null;
          if (!isSupervisorView && plan.restricted) return null;
          const installmentSizeDollar = divide(plan.installment_size, 100);
          if (installmentSizeDollar >= min && installmentSizeDollar <= max) {
            return plan;
          }
          return null;
        })
      );
      setFilteredPlanOffers(filtered);
      modal.hide();
    };

    const onClearFilter = () => {
      setFilteredPlanOffers(allPlanOffers);
      setMin(0);
      setMax(divide(totalBalance, 100));
      modal.hide();
    };

    return (
      <CustomDialog
        title={"Set amount range"}
        buttonText={"Apply"}
        onClick={onApplyFilter}
        secondaryButtonText={"Clear filter"}
        onClickSecondary={onClearFilter}
      >
        <Container fullWidth sx={{gap: "16px", alignItems: "start", overflow: "auto"}}>
          <Text variant={"inter500"}>Enter a minimum and maximum amount to customize your range</Text>
          <Container fullWidth row>
            <TextField
              type={"number"}
              value={min}
              fullWidth
              onChange={(event) => setMin(Number(event.target.value))}
              error={min > max}
              label={"Min"}
              InputProps={{
                style: {borderRadius: "8px"},
                slotProps: {
                  input: {
                    style: {fontWeight: 500},
                    min: 0,
                    max,
                  },
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={{color: "text.primary", fontWeight: 500}}>{"$"}</Typography>
                  </InputAdornment>
                ),
              }}
              sx={{backgroundColor: Colors.bw.white}}
            />
            <TextField
              type={"number"}
              value={max}
              fullWidth
              onChange={(event) => setMax(Number(event.target.value))}
              error={maxAmount < max || max < min}
              label={"Max"}
              InputProps={{
                style: {borderRadius: "8px"},
                slotProps: {
                  input: {
                    style: {fontWeight: 500},
                    min,
                    max: divide(totalBalance, 100),
                  },
                },
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography sx={{color: "text.primary", fontWeight: 500}}>{"$"}</Typography>
                  </InputAdornment>
                ),
              }}
              sx={{backgroundColor: Colors.bw.white}}
            />
          </Container>
        </Container>
      </CustomDialog>
    );
  }
);

export default FilterOffersDialog;
